module.exports = __webpack_public_path__ + "media/images/point_exchange-ce772490b5da680fd8e397bc7157fe97.svg";